import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { selectors } from 'src/store';
import Container from 'src/components/pages/Activities/FindWords/Levels/Container';

import coverImage from 'src/images/findWords/waterLilyCover.svg';

const FindWordsStepThreeExtraLevels = ({
  currency,
  levels,
  getLevelsByCollectionId,
  hasLoaded,
  student,
  ...props
}) => {
  useEffect(() => {
    getLevelsByCollectionId();
  }, [getLevelsByCollectionId]);

  return (
    <Container
      className="find-words-levels-container--step-three-extra"
      coverImage={coverImage}
      hasLoaded={hasLoaded}
      items={levels}
      currency={currency}
      student={student}
      {...props}
    />
  );
};

FindWordsStepThreeExtraLevels.propTypes = {
  currency: PropTypes.shape({}),
  levels: PropTypes.arrayOf(PropTypes.shape({})),
  getLevelsByCollectionId: PropTypes.func.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  student: PropTypes.shape({}).isRequired,
};

FindWordsStepThreeExtraLevels.defaultProps = {
  currency: null,
  levels: [],
};

const mapStateToProps = (state) => ({
  hasLoaded: selectors.dailyMap.getHasLoadedLevels(state),
  currency: selectors.dailyMap.getDailyMapCollection(state)?.currency,
  levels: selectors.dailyMap.getDailyMapCollection(state)?.levels,
  student: selectors.authentication.getStudent(state),
});

const mapDispatchToProps = {};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  memo
)(FindWordsStepThreeExtraLevels);
